import React, { useMemo } from "react";
import "../../Materiels/utils/StockSummaryCard.css";

const VehicleSummaryCards = ({ vehicles = [] }) => {
  const groupedBrands = useMemo(() => {
    if (!vehicles?.length) return [];

    const grouped = vehicles.reduce((acc, vehicle) => {
      const key = vehicle.brand?.trim().toLowerCase();

      if (!acc[key]) {
        acc[key] = {
          label: vehicle.brand,
          value: 0,
        };
      }

      acc[key].value += 1;

      return acc;
    }, {});

    const sorted = Object.values(grouped).sort(
      (a, b) => b.value - a.value
    );

    if (sorted.length <= 4) {
      return sorted;
    }

    const topThree = sorted.slice(0, 3);

    const othersCount = sorted.length - 3;

    const othersTotal = sorted
      .slice(3)
      .reduce((sum, item) => sum + item.value, 0);

    return [
      ...topThree,
      {
        label: `+${othersCount} autres`,
        value: othersTotal,
        isOthers: true,
      },
    ];
  }, [vehicles]);

  return (
    <div className="stock-summary-wrapper">
      <div className="stock-summary-grid">
        {groupedBrands.map((item, index) => (
          <div
            key={`${item.label}-${index}`}
            className={`stock-summary-card ${
              item.isOthers
                ? "stock-summary-card-others"
                : ""
            }`}
          >
            <div className="stock-summary-card-name">
              {item.label}
            </div>

            <div className="stock-summary-card-value">
              {item.value}
            </div>

            <div className="stock-summary-card-label">
              véhicule{item.value > 1 ? "s" : ""}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VehicleSummaryCards;